import { Breakpoints, styled } from "@vw-marketing/us-components";


export const StyledDealerReviewCardContainer = styled.div`${({theme, hasReviews}) => `
display: grid;
grid-template-areas: "name" "map" "address" "contact" "rating" "disclaimer";
grid-template-columns: 1fr;
@media (min-width: ${Breakpoints.b960}px) { 
    width: calc(100vw - ${theme.size.grid004} - 130px);
    grid-template-areas: ${ hasReviews ? 
        '"name name" "map rating" " map address" "map contact" "disclaimer disclaimer"' :
        '"name name" " map address" "map contact" "disclaimer disclaimer"'
    };
    grid-template-columns: 50% 50%;
}


.dealer-name-wrapper {
    width: 100%;
    grid-area: name;
    margin-bottom: 30px;
}

.dealer-map-wrapper {
    width: 100%;
    grid-area: map; 
    @media (min-width: ${Breakpoints.b960}px) { 
        padding-right: 30px;
    }
}

.rating-wrapper {
    width: 100%;
    grid-area: rating;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 20px;
    border-bottom: 1px solid #DFE4E8;
    .rating-stars-wrapper {
        display: flex;
        column-gap: 5px;
        color: #758189;
    }
    @media (min-width: ${Breakpoints.b960}px) { 
        padding: 30px;
        padding-bottom: 0;
        justify-content: left;
        align-items: baseline;
        border-bottom: none;
    }
}

.dealer-address-wrapper {
    width: 100%;
    grid-area: address;
    padding-top: 15px;
    padding-bottom: 30px;
    @media (min-width: ${Breakpoints.b960}px) { 
        padding: 30px;
        padding-bottom: 0;
    }

}
.dealer-reviews-disclaimer {
    grid-area: disclaimer;
    margin-top: 30px;
}
.dealer-contact-wrapper {
    width: 100%;
    grid-area: contact;
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    row-gap: 15px;
    flex-direction: column;
    padding-bottom: 30px;
    .dealer-contact-item {
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 5px;
        color: #001E50;
        span {
            margin: 0;
        }
    }
    @media (min-width: ${Breakpoints.b960}px) { 
        padding: 30px;
        padding-bottom: 0;
    }
}
`}`